export interface Notification {
  uId: string;
  organizationUId?: string;
  datasetUId?: string;
  documentUId?: string;
  notificationChannelUId?: string;
  fromIcon?: string;
  fromName?: string;
  distance?: number;
  geometry?: string;
  dateSent?: any;
  messageType?: NotificationType;
  notificationStatus?: NotificationStatus;
  translations?: NotificationTranslation[];
  isTransient?: boolean;
  soundUrl?: string;
}

export interface NotificationTranslation {
  cultureCode: string;
  subject: string;
  message: string;
  location: string;
}

export enum NotificationType {
  NotSet = 0,
  Comment = 1,
  Communication = 2,
  MassCommunication = 3,
  Alert = 4
}
export enum NotificationTopicType {
  NotSet = 0,
  User = 1,
  DatasetDocument = 2,
  MassNotificationRecipientEscalated = 3
}

export enum NotificationStatus {
  Unread = 0,
  Read = 1
}

export const GeneralChannelUId = '00000000-0000-0000-0000-000000000000';
export const EscalatedMessagesTopicUId = '8004bc90-ef31-4a3a-a188-1fda70155958';

export interface NotificationSound {
  displayName: string;
  url: string;
}

export const NotificationSounds: NotificationSound[] = [
  { displayName: 'NOTIFICATIONS.SOUND-ALARMED', url: 'https://files.topo.ai/sounds/Alarmed.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-BEEPER', url: 'https://files.topo.ai/sounds/Beeper.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-BELLIGERENT', url: 'https://files.topo.ai/sounds/Belligerent.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-CALM', url: 'https://files.topo.ai/sounds/Calm.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-CHORD', url: 'https://files.topo.ai/sounds/Chord.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-CHORD-2', url: 'https://files.topo.ai/sounds/Chord2.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-CLOUD', url: 'https://files.topo.ai/sounds/Cloud.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-DOORBELL', url: 'https://files.topo.ai/sounds/Doorbell.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-ENHARPMENT', url: 'https://files.topo.ai/sounds/Enharpment.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-FLUTE', url: 'https://files.topo.ai/sounds/Flit_Flute.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-GLASS', url: 'https://files.topo.ai/sounds/Glass.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-GLISTEN', url: 'https://files.topo.ai/sounds/Glisten.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-GLITCH', url: 'https://files.topo.ai/sounds/Glitch.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-INFORMATION-BELL', url: 'https://files.topo.ai/sounds/Information_Bell.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-INFORMATION-BLOCK', url: 'https://files.topo.ai/sounds/Information_Block.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-JINJA', url: 'https://files.topo.ai/sounds/Jinja.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-JINJA-2', url: 'https://files.topo.ai/sounds/Jinja2.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-KOTO', url: 'https://files.topo.ai/sounds/Koto.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-MODULAR', url: 'https://files.topo.ai/sounds/Modular.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-NEWSFLASH', url: 'https://files.topo.ai/sounds/Newsflash_Bright.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-PIZZA-BOX', url: 'https://files.topo.ai/sounds/PizzaBox.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-POLITE', url: 'https://files.topo.ai/sounds/Polite.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-PONDEROUS', url: 'https://files.topo.ai/sounds/Ponderous.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-REVERIE', url: 'https://files.topo.ai/sounds/Reverie.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-SHARP', url: 'https://files.topo.ai/sounds/Sharp.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-SONAR', url: 'https://files.topo.ai/sounds/Sonar.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-TAPTAP', url: 'https://files.topo.ai/sounds/Taptap.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-TECH', url: 'https://files.topo.ai/sounds/Tech.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-UNPHASED', url: 'https://files.topo.ai/sounds/Unphased.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-UNSTRUNG', url: 'https://files.topo.ai/sounds/Unstrung.ogg' },
  { displayName: 'NOTIFICATIONS.SOUND-WORMS', url: 'https://files.topo.ai/sounds/worms-incoming.mp3' }
];
